import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UbsBlogComponent } from './components/ubs-blog/ubs-blog.component';
import { UbsBlogComponentsComponent } from './ubs-blog-components.component';
import { NbMenuItem } from '@nebular/theme';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { UbsBlogArticleListComponent } from './components/ubs-blog-article-list/ubs-blog-article-list.component';
import { UbsBlogArticleEditComponent } from './components/ubs-blog-article-edit/ubs-blog-article-edit.component';
import { UbsBlogEditComponent } from './components/ubs-blog-edit/ubs-blog-edit.component';

export const routes: Routes = [
  {
    path:'',
    component:UbsBlogComponentsComponent,
    children:[
      {
        path:'',
        component:UbsBlogComponent,
      },
      {
        path:':blogContentId',
        component:UbsBlogComponent,
      },
      {
        path:':blogContentId/update',
        component:UbsBlogEditComponent,
      },
      {
        path:':blogContentId/articles',
        component:UbsBlogArticleListComponent,
      },
      {
        path:':blogContentId/article/:articleContentId',
        component:UbsBlogArticleEditComponent,
      },
      {
        path:':blogContentId/new',
        component:UbsBlogArticleEditComponent,
      },
      {
        path:':blogContentId/:contentId/:contentName',
        component:UbsBlogComponent,
      },
      {
        path:':contentId/:contentName',
        component:UbsBlogComponent
      }
    ]
  },
  
];

const MENU_ITEMS:NbMenuItem[] = [
  /* {
    title: 'Websites',
    icon: 'globe-outline',
    link: '/admin/cms/websites',
    home: true,
  },
  {
    title: 'Content',
    icon: 'file-text-outline',
    link: '/admin/cms/content',
    home: true,
  } */
];
const headerTitle:string = "BLOG";
const path:string = "blog";
const menuTag:string = "blogMenu"
const menuAndTitleOptions = {path:path,menuItems:MENU_ITEMS,headerTitle:headerTitle,menuTag:menuTag};


@NgModule({
  //declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    UbsViewContainersModule
  ],
  exports: [RouterModule,UbsViewContainersModule],
})
export class BlogRoutingModule {
  constructor(private viewContainerService:ViewContainersService){
    let currentItems = this.viewContainerService.menuAndTitleOptions$.getValue();
    console.log(currentItems);
    let updated = currentItems.concat(menuAndTitleOptions);
    this.viewContainerService.menuAndTitleOptions$.next(updated);
    //this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),menuAndTitleOptions]);
    //this.viewContainerService.menuAndTitleOptions$.next(menuAndTitleOptions);
    this.viewContainerService.activeMenuTag$.next(menuTag);
    //this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)
  }
 }
